import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPathLanguage, withLanguagePrefix } from "@/lib/i18n";

export const useLocalizedNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (to, options) => {
      const lang = getPathLanguage(location.pathname);
      if (typeof to === "string") {
        navigate(withLanguagePrefix(to, lang), options);
        return;
      }

      if (to?.pathname) {
        navigate({ ...to, pathname: withLanguagePrefix(to.pathname, lang) }, options);
        return;
      }

      navigate(to, options);
    },
    [location.pathname, navigate]
  );
};
